import {
  AutocompleteComponent,
  AutocompleteLoadingModeType,
  IAutocompleteSchema,
  ToastService
} from "maps-angular-components";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { Associacao } from "../associacao";
import { AssociacaoService } from "../associacao.service";
import { AutocompleteItem } from "../../../shared/models/autocomplete.model";
import { Carteira, CarteiraAutocompleteModel, GrupoCarteira } from "../../../carteira/carteira.model";
import { CarteiraService } from "../../../carteira/carteira.service";
import { CarteiraGrupoAutocompleteService } from "src/app/carteira/carteira-grupo-autocomplete.service";
import { CarteiraAutocompleteMapper } from "src/app/shared/components/carteira-autocomplete/carteira-autocomplete.mapper";
import { GrupoCarteiraService } from "src/app/carteira/grupo-carteira.service";

@Component({
  selector: "selecao-carteira",
  templateUrl: "./selecao-carteira.component.html",
  styleUrls: ["./selecao-carteira.component.scss"],
})
export class SelecaoCarteiraComponent implements OnInit {
  @Input() form: FormGroup;
  public carteiraSchema: IAutocompleteSchema<CarteiraAutocompleteModel>;
  carteiras: Carteira[] = [];
  @Output() onCarteiraChange: EventEmitter<Carteira[]> = new EventEmitter<Carteira[]>();
  @ViewChild("selecaoCarteiraAutocomplete", { static: false }) carteiraAutocomplete: AutocompleteComponent<CarteiraAutocompleteModel>;

  page = 1;
  private carteiraHolder: Carteira;

  constructor(
    public associacaoService: AssociacaoService,
    private readonly messageService: ToastService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly formBuilder: FormBuilder,
    private readonly carteiraService: CarteiraService,
    private readonly grupoCarteiraService: GrupoCarteiraService,
    private readonly carteiraGrupoAutocompleteService: CarteiraGrupoAutocompleteService,
    private readonly carteiraAutocompleteMapper: CarteiraAutocompleteMapper
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      carteiraId: new FormControl(),
    });
    this.carteiraSchema = {
      service: this.carteiraGrupoAutocompleteService,
      label: "",
      placeholder: "",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "",
      formGroup: this.form,
      formControlName: "carteiraId",
      panelClass: "large-input",
      parseSearchParam(search): string {
        return search;
      },
    };
  }

  doAdicionarCarteira(carteira: Carteira) {
    if (this.carteiras.some(c => carteira.nome === c.nome)) {
      this.messageService.alerta(`Carteira ${carteira.nome} já selecionada.`);
      return;
    }

    this.associacaoService.addCarteira(carteira, this.carteiras);
  }

  async getCarteirasByGroup(nome: string): Promise<Carteira[]> {
    let grupoCarteira = await this.grupoCarteiraService.findAllByGroup(nome).toPromise();

    return grupoCarteira.carteiras;
  }

  async adicionarCarteira(value) {

    if (!this.carteiraHolder) {
      return;
    }

    const isGrupo = this.form.value.carteiraId.includes('|GRUPO')
    this.carteiraHolder.id = this.carteiraAutocompleteMapper.removePipe(this.form.value.carteiraId)

    if (isGrupo) {
      const carteirasGrupo = await this.getCarteirasByGroup(this.carteiraHolder.nome)

      if (carteirasGrupo.length === 0) {
        this.messageService.erro(`O grupo ${this.carteiraHolder.nome} não possui carteiras`)
      }

      carteirasGrupo.forEach(c => {
        c.name = c.nome + ' (' + c.cnpjFormatado + ')'
        this.doAdicionarCarteira(c);
      })
    }

    else {
      this.doAdicionarCarteira(this.carteiraHolder);
    }

    this.carteiraAutocomplete.reset();
    this.carteiraHolder = null;
    this.changeDetectorRef.detectChanges();
    this.onCarteiraChange.emit(this.carteiras);
  }

  remove(s: any) {
    this.associacaoService.removerCarteira(s, this.carteiras);
    this.onCarteiraChange.emit(this.carteiras);
  }

  receiverPage(e: any) {
    this.page = e;
  }

  getCarteirasPaging() {
    return this.getCarteiras(this.page);
  }

  getCarteiras(page: number) {
    const carteirasModel: Carteira[] = [];
    const start = page * 10 - 10;
    for (let i = start; i < page * 10 && i < this.carteiras.length; i++) {
      carteirasModel.push(this.carteiras[i]);
    }
    return carteirasModel;
  }

  clear() {
    this.carteiraAutocomplete.reset();
    this.carteiras = [];
  }

  carteiraSelecionada(carteira: CarteiraAutocompleteModel) {
    this.carteiraHolder = new Carteira();
    this.carteiraHolder.id = carteira.id;
    this.carteiraHolder.name = carteira.descricao;
    this.carteiraHolder.nome = carteira.nome
  }

}
